<template>
  <SelectionTreeListItem
    v-model="value"
    :data="data"
    :node-text="nodeText"
  />
</template>
<script>
import SelectionTreeListItem from '@/components/SelectionTreeListItem.vue';
import EventBus from '@/services/eventBus';

export default {
  name: 'SelectionTreeList',
  components: {
    SelectionTreeListItem,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    nodeText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      asd: null,
    };
  },
  mounted() {
    EventBus.$on('selected', (payload) => {
      this.$emit('input', payload);
    });

    EventBus.$on('completed', (payload) => {
      this.$emit('completed', payload);
    });
  },
};
</script>
<style>
.card {
  min-height: 90px;
}
</style>
